<template>
  <sidebar-row align-class="align-start" :border-top="borderTop">
    <template #actionIcon>
      <v-icon :color="disabled ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.7)'" :size="iconSize" v-text="icon" />
    </template>
    <template #default>
      <v-tooltip bottom color="font" :disabled="!tooltipText">
        <template #activator="{ on: onTooltip }">
          <v-col
            cols="auto"
            :class="{
              'pt-1': true,
              'sidebar-text-button': true,
              'sidebar-text-button-disabled': disabled,
              'sidebar-text-button-active': !disabled,
            }"
            class="text-left px-0"
            @click="action"
            v-on="onTooltip"
          >
            {{ $i18n.t(textTranslationPath) }}
          </v-col>
        </template>
        {{ tooltipText }}
      </v-tooltip>
    </template>
  </sidebar-row>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'SidebarTextButton',
  components: { SidebarRow },
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: '20px',
    },
    textTranslationPath: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
    },
  },
  methods: {
    action() {
      if (this.disabled) {
        return;
      }
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-text-button {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
}
.sidebar-text-button-disabled {
  color: rgba(32, 33, 36, 0.4);
  cursor: default;
}
.sidebar-text-button-active:hover {
  text-decoration: underline;
}
.sidebar-text-button-active {
  color: rgba(32, 33, 36, 1);
  cursor: pointer;
}
</style>
